import localize from '../../common/localize';
import ModalBackground from './ModalBackground';

export default function ErrorMessage({
  title,
  setTitle,
  message,
  showModal,
  setShowModal,
}) {
  return (
    <ModalBackground
      showModal={showModal}
      setShowModal={setShowModal}
      title={title}
      onClickToSubmit={() => {
        if (setTitle) setTitle(localize.error_unexpected);
        setShowModal(false);
      }}
      hideCancelButton
      okButtonText={localize.ok}
      Component={
        <div className="main_application_foreground_color w-full p-2">
          <p>{message}</p>
        </div>
      }
    />
  );
}
